import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get } from 'lodash';

const RedirectExternalSite = ({ checkinData }) => {
  setTimeout(() => {
    window.location.href = get(checkinData, 'data.data.redirectUrl', '');
  }, 1500);
  return null;
};

RedirectExternalSite.propTypes = {
  checkinData: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  checkinData: state.screen.checkinData,
});

export default connect(mapStateToProps)(RedirectExternalSite);
